
import { request } from '../../../public/js/request'
// store/modules/todo.js
const todo = {
  namespaced: true,
  state: () => ({
      // 初始值设为 null，方便判断是否已经加载过数据
      todoResult: null 
  }),
  mutations: {
      SET_TODO_RESULT(state, data) {
          state.todoResult = data;
      }
  },
  actions: {
      // 获取待办数据的异步方法
      async fetchTodoData({ commit, rootState }) {
        try {
            //待办任务接口请求
            const res = await request({ url: 'B2B_W_BACKLOG_BACKLOG', method: 'post', data: {"backlogSource": "0"} })
            // 1. 修改本模块的状态
            console.log(res)
            commit('SET_TODO_RESULT', res.data.result);

        } catch (error) {
            console.error('获取待办失败', error);
        }
    }
  },
  getters: {
      // 给头部组件用的总数
      totalCount: (state) => state.todoResult?.backlogCount || 0,
      // 给详情页面用的其他项数量
      otherCounts: (state) => {
          if (!state.todoResult) return {};
          // 解构出 total，剩下的就是“其他项”
          const { backlogCount, ...others } = state.todoResult;
          return others;
      }
  }
}
export default todo;